import * as React from "react";
import { SpirometrySessionMetadata, SpirometryAnalysisSet, OverreadChallengeStatusEnum, OverreadStatusIdEnum, ChallengeableAnalysisSet } from '../../misc/api/apiTypes';

export const GetOverreadAnalysisSet = (session: SpirometrySessionMetadata): SpirometryAnalysisSet => {
    return session.AnalysisSets.find(spAs => spAs.Type.Id === "SAS_OVERREAD");
}

export const GetSiteAnalysisSet = (session: SpirometrySessionMetadata): SpirometryAnalysisSet => {
    return session.AnalysisSets.find(spAs => spAs.Type.Id === "SAS_SITE");
}

export interface ChallengeStatusProps {
    overreadAnalysisSet: ChallengeableAnalysisSet;
    challengeStatus: string;
}

export const ChallengeStatus = ({ overreadAnalysisSet, challengeStatus }: ChallengeStatusProps) => <>{overreadAnalysisSet.Status.Name} <span className="label label-danger">{challengeStatus}</span></>;

export const GetOverreadSessionStatus = (session: SpirometrySessionMetadata): React.ReactNode => {
    const overreadAnalysisSet = GetOverreadAnalysisSet(session);

    if (overreadAnalysisSet) {
        if (!session.ChallengeIsClosed && session.ChallengeStatusId === OverreadChallengeStatusEnum.Challenged && (overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Accepted || overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Rejected)) {
            return <ChallengeStatus overreadAnalysisSet={overreadAnalysisSet} challengeStatus={session.ChallengeStatus} />;
        }

        return overreadAnalysisSet.Status.Name;
    } else {
        return session.Status;
    }
}

export const GetSiteSessionStatus = (session: SpirometrySessionMetadata): React.ReactNode => {
    const siteAnalysisSet = GetSiteAnalysisSet(session);

    if (siteAnalysisSet) {
        return siteAnalysisSet.Status.Name;
    } else {
        return session.Status;
    }
}

export const GetAnalysisStatus = (overreadAnalysisSet: ChallengeableAnalysisSet): React.ReactNode => {
    if (!overreadAnalysisSet.ChallengeIsClosed && overreadAnalysisSet.ChallengeStatusId === OverreadChallengeStatusEnum.Challenged && (overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Accepted || overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Rejected)) {
        return <ChallengeStatus overreadAnalysisSet={overreadAnalysisSet} challengeStatus={overreadAnalysisSet.ChallengeStatus} />;
    }

    return overreadAnalysisSet.Status.Name;
}

